import generalUpload from "../_section/upload.class";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
export class userAccountStatementUpload extends generalUpload {
    constructor(request, upload, queries, data) {
        super(request, upload, queries, data);
        this.balances = (upload.balances?.items || []).filter(it=>!it._deleted).map(b => {
            return {
                date: b?.date ? dayjs.isDayjs(b.date) ? b.date : dayjs(b.date, "YYYY-MM-DD").local().startOf('day') : null,
                balance: b.balance,
                uploadID: upload.id,
            }
        }).sort((a, b) => {
            return a.date.isBefore(b.date) ? -1 : 1;
        })



        // if (this.balances.length) {
        //     this.setDateData({
        //         dated: this.balances[0].date,
        //         range: {
        //             from: this.balances[0],
        //             to: this.balances[this.balances.length - 1],
        //         },
        //         expires: this.balances[this.balances.length - 1].date.add(6, 'month'),
        //     })
        // }
    }

    isDateInUpload(date){
        if (!dayjs.isDayjs(date)) {
            date = dayjs(date, "YYYY-MM-DD").local().startOf('day');
        }
        else{
            date = date.local().startOf('day');
        }

        if (!this?.dateData?.range?.ok) {

            return false; // if range is not ok, we cannot have a date in it
        }

        return !!(date.isSameOrBefore(this.dateData.range.to.date) && date.isSameOrAfter(this.dateData.range.from.date));
    }
    adjustmentsBetweenDates(startDate, endDate) {
        if (!dayjs.isDayjs(startDate)) {
            startDate = dayjs(startDate, "YYYY-MM-DD").local().startOf('day');
        }
        if (!dayjs.isDayjs(endDate)) {
            endDate = dayjs(endDate, "YYYY-MM-DD").local().startOf('day');
        }

        const queriesWithAdjustment = this.queries.filter(query=> {
            if ( query.adjustmentAmount && query.adjustmentDirection ) {
                if (query.date) {
                    let d = dayjs(query.date, "YYYY-MM-DD").local().startOf('day');
                    return d.isSameOrAfter(startDate) && d.isSameOrBefore(endDate);
                }
            }
            return false
        });

        const adjustmentRows = queriesWithAdjustment.map(query => {

            return {
                date: dayjs(query.date, "YYYY-MM-DD").local().startOf('day'),
                amount: query.adjustmentAmount,
                direction: query.adjustmentDirection,
                list: query.adjustmentList,
                reoccurring: query.reoccurring || false,
                uploadID: query.referenceId,
                title: query.title,
                query: query.query,
                queryID: query.id,
                lenderAnswer: query.lenderAnswer,
            }
        })

        return adjustmentRows
    }

    balanceOnDate(date) {
        const response = {}
        if (!dayjs.isDayjs(date)) {
            date = dayjs(date, "YYYY-MM-DD").local().startOf('day');
        }
        const balances = this.balances.filter(it => it.date.isSame(date, 'day'));
        if (!balances.length) {
            response.errors = [`No balance on ${date.format("YYYY-MM-DD")}`];
        } else if (balances.length > 1) {
            response.errors = [`Multiple balances on ${date.format("YYYY-MM-DD")}`];
        }
        response.balance = balances[0] || null;
        return response
    }

}
const template= {
    items: [
        {
            name: 'iban',
            label: 'IBAN',
            type: 'text',
            scan: 'accountNumber'
        }, {
            name: 'openingBalance',
            label: 'Opening Balance',
            type: 'currency',
            scan: 'openingBalance',
            optional: true
        }, {
            name: 'closingBalance',
            label: 'Closing Balance',
            type: 'currency',
            scan: 'closingBalance',
            optional: true
        }, {
            name: 'startDate',
            label: 'Start Date',
            type: 'date',
            scan: 'startDate',
            optional: true
        }, {
            name: 'endDate',
            label: 'End Date',
            type: 'date',
            scan: 'endDate',
            optional: true
        }, {
            name: 'vault1OpeningBalance',
            label: 'Opening Balance',
            type: 'currency',
            optional: true
        }, {
            name: 'vault1ClosingBalance',
            label: 'Closing Balance',
            type: 'currency',
            optional: true
        }, {
            name: 'vault2OpeningBalance',
            label: 'Opening Balance',
            type: 'currency',
            optional: true
        }, {
            name: 'vault2ClosingBalance',
            label: 'Closing Balance',
            type: 'currency',
            optional: true
        }
    ]

}
export class adminAccountStatementUpload extends userAccountStatementUpload {

    constructor(request, upload, queries, data) {
        super(request, upload, queries, data);
        this.calcValues(template)

        // if (this.balances.length) {
        //     this.setDateData({
        //         dated: this.balances[0].date,
        //         range: {
        //             from: this.balances[0],
        //             to: this.balances[this.balances.length - 1],
        //         },
        //         expires: this.balances[this.balances.length - 1].date.add(6, 'month'),
        //     })
        // }
        if (this.values.endDate) {

            this.setDateData({
                dated: this.values.endDate.local().startOf('day'),
                range:{
                    from:{
                        date: this.values.startDate?.local()?.startOf('day'),
                    },
                    to: {
                        date: this.values.endDate.local().startOf('day'),
                    }
                },
                expires: this.values.endDate.add(8, 'month'),
            })
        }
        if (this.values.iban && data.accountNumber ){
            if (this.values.iban.replace(/\s/g, '').toUpperCase() !== data.accountNumber.replace(/\s/g, '').toUpperCase()){
                this.problems.push(`IBAN does not match this section's account number`);
            }
        }
        if (!upload.examined && !['SETUP','APPLY'].includes(request.mortgage.applicationStage)){
            this.problems.push('Not Examined');
        }
    }


}
